export const metersToFeet = (value) => {
	return (value / 3.28084);
}

export const celciusToFarenheit = (value) => {
	return (value * 1.8) + 32;
}

export const farenheitToCelsius = (value) => {
	return parseFloat(((value - 32) * (5 / 9)).toFixed(2));
}

export const poundsToGrams = (value) => {
	return value * 453.592;
}

export const kilogramsToGrams = (value) => {
	return value * 1000;
}

export const ouncesToGrams = (value) => {
	return value * 28.3495;
}
